import React from 'react';
import { MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';


export default class Achievers extends React.Component {
    // Alois Changing something
    constructor(props) {
        super(props);
        this.state = {
            achievers: []
        }
        this.formatter = new Formatter();
    }

    async componentWillMount(nextProps) {
        this.props.loaderOn();
        var dl = new DataLayer();
        await dl.Get('/common/getachievers', 200).then((response) => {
            this.setState({
                achievers: response.data
            });
            this.props.loaderOff();
        })

    }

    render() {
        return (
            <div>
                <Header headerText="Top Achievers"
                    hideSearch={true}
                />
                <MDBRow>
                    {
                        this.state.achievers.map((achiever) => {
                            if (achiever.lvl == "Top") {
                                return (
                                    <MDBCol xl="4" lg="4" md="6" sm="12" className="mb-r" >
                                        <MDBCard className="card-body" style={{ marginTop: "1rem", padding: "0px" }}>
                                            <div style={{ padding: "8px" }}>
                                                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="users" />&nbsp;{achiever.unitName.toUpperCase()}</MDBCardTitle>
                                                <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{achiever.managerName.toUpperCase()}</MDBCardTitle>
                                                <MDBCardTitle style={{ fontSize: "12px" }}>&nbsp;<MDBIcon icon="phone" />&nbsp;&nbsp;{achiever.telephoneCell}</MDBCardTitle>
                                            </div>
                                            <hr style={{ marginLeft:"6px", marginRight:"6px", backgroundColor: "#ad1896" }} />
                                            <MDBCardText style={{ padding: "4px", marginBottom: "1rem"}}>
                                                <MDBRow>
                                                    <MDBCol xl="4" lg="4" md="4" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                                        <span style={{ fontSize: "14px" }}>Sales</span><br /> <strong>{this.formatter.formatCurrency(achiever.unit.totalUnitSales)}</strong>
                                                    </MDBCol>
                                                    <MDBCol xl="4" lg="4" md="4" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                        <span style={{ fontSize: "14px" }}>Recruits</span><br /> <strong>{achiever.unit.newRecruits}</strong>
                                                    </MDBCol>
                                                    <MDBCol xl="4" lg="4" md="4" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                        <span style={{ fontSize: "14px" }}>P/O's</span><br /> <strong>{achiever.unit.promoteOuts}</strong>
                                                    </MDBCol>
                                                    
                                                </MDBRow>
                                        </MDBCardText>
                                           

                                        </MDBCard>
                                    </MDBCol>
                                )
                            }
                        })
                    }
                </MDBRow>
                <MDBRow style={{marginTop:"2rem"}}>
                    <MDBCol md="6" sm="12">
                        <h2>Bottom Achievers</h2>
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    {
                        this.state.achievers.map((achiever) => {
                            if (achiever.lvl != "Top") {
                                return (
                                    <MDBCol xl="4" lg="4" md="6" sm="12" className="mb-r" >
                                        <MDBCard className="card-body" style={{ marginTop: "1rem", padding: "0px" }}>
                                            <div style={{ padding: "8px" }}>
                                                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="users" />&nbsp;{achiever.unitName.toUpperCase()}</MDBCardTitle>
                                                <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{achiever.managerName.toUpperCase()}</MDBCardTitle>
                                                <MDBCardTitle style={{ fontSize: "12px" }}>&nbsp;<MDBIcon icon="phone" />&nbsp;&nbsp;{achiever.telephoneCell}</MDBCardTitle>
                                            </div>
                                            <hr style={{ marginLeft: "6px", marginRight: "6px", backgroundColor:"#ad1896"}}/>
                                            <MDBCardText style={{ padding: "4px", marginBottom:"1rem" }}>
                                                <MDBRow>
                                                    <MDBCol xl="4" lg="4" md="4" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                                        <span style={{ fontSize: "14px" }}>Sales</span><br /> <strong>{this.formatter.formatCurrency(achiever.unit.totalUnitSales)}</strong>
                                                    </MDBCol>
                                                    <MDBCol xl="4" lg="4" md="4" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                        <span style={{ fontSize: "14px" }}>Recruits</span><br /> <strong>{achiever.unit.newRecruits}</strong>
                                                    </MDBCol>
                                                    <MDBCol xl="4" lg="4" md="4" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                        <span style={{ fontSize: "14px" }}>P/O's</span><br /> <strong>{achiever.unit.promoteOuts}</strong>
                                                    </MDBCol>

                                                </MDBRow>
                                            </MDBCardText>
                                            

                                        </MDBCard>
                                    </MDBCol>
                                )
                            }
                        })
                    }
                </MDBRow>
            </div>
        );
    }
}